import React, {useState, useEffect, useContext} from "react";
import {
  UnorderedList,
  ListItem,
  Container, Button, VStack,
  HStack,
  Grid,
  GridItem,
} from '@chakra-ui/react';
import {useNavigate} from "react-router-dom";
import {client} from "@/client"
import {GlobalContext, bearerToken, emptyUser} from "@/auth";

import {
  Page,
  PageHeader,
  PageBody,
} from "@/components/layout"
import { Directory, RegistrationLog } from "@/pbgen/v1/main_pb";

function drawTree(root: Directory) {
  return (<UnorderedList>
    {root.files.map((f) =>
      <ListItem>{f.base}</ListItem>
    )}
    {
      root.directories.map((d) =>
        <>
          <ListItem>{d.base}</ListItem>
          {drawTree(d)}
        </>
      )
    }
  </UnorderedList>);
}

export const Registration = () => {
  const [root, setRoot] = useState<Directory>(new Directory());
  const [status, setStatus] = useState("");
  const [currentUser, setCurrentUser] = useState("")
  const [logs, setLogs] = useState<RegistrationLog[]>([])

  const {globalState, setGlobalState} = useContext(GlobalContext);
  useEffect(() => {
    (async () => {
      const resp = await client.getCoursewareFileTree({bearerToken: bearerToken()});
      setGlobalState({...globalState, currentUser: resp.currentUser ?? emptyUser()})

      setCurrentUser(resp.currentUser?.optName ?? "")
      setRoot(resp.root ?? new Directory());
      setStatus("最終更新: " + resp.updatedAt);
    })();
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const navigate = useNavigate();

  const register = async function() {
    setStatus("更新中...")
    const resp = await client.registerCoursewares({bearerToken: bearerToken()});
    if (resp.error) {
      setStatus("更新失敗: " + resp.error)
      return
    }
    setStatus("最終更新: " + resp.updatedAt);
    console.log(resp)
  }

  useEffect(() => {
    const interval = setInterval(async () => {
      const resp = await client.getRegistrationLogs({bearerToken: bearerToken()});
      setLogs(resp.logs)
    }, 2000);
    return () => clearInterval(interval);
  }, []);

  return <Page>
    <PageHeader title={"教材管理"}>
      <HStack padding={2}>
        <Button onClick={register}>登録</Button>
        {/* <Button onClick={() => {navigate("..", { relative: "path" })}}>戻る</Button> */}
        <Button isDisabled={window.history.length <= 2} onClick={() => {navigate(-1)}}>戻る</Button>
      </HStack>
    </PageHeader>
    <PageBody>
      <Grid templateColumns="repeat(2, 1fr)" gap={6}>
        <GridItem w="100%">
        <VStack spacing={6}>
          {drawTree(root)}
        </VStack>
        </GridItem>
        <GridItem w="100%">
          <VStack spacing={6}>
            <p>{status}</p>
            <UnorderedList>
            {logs.map((log) => {
              /* console.log(log.id.toString()); hayashida */
              return <ListItem key={log.id.toString()}>{log.text}</ListItem>
            })}
            </UnorderedList>
          </VStack>      
        </GridItem>
      </Grid>
    </PageBody>
  </Page>
}
